import { createPortal } from 'react-dom';
import React, { Fragment, useState, useContext, useRef, useEffect } from 'react';
import { withStyles, Grid, Drawer, Divider } from '@material-ui/core';
import DataContext from '../data/DataContext';
import Close from '../../asset/img/icon_close.svg';

const styles = (theme) => ({
  root: {
    display: 'flex',
  },
  drawerContainer: {
    width: '100%',
    position: 'fixed',
    zIndex: '1300',
    inset: '0',
  },
  drawerFrame: {
    borderRadius: '0.625rem',
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    height: '80%',
    overflowY: 'auto',
    transform: 'none',
    transition: 'transform 225ms cubic-bezier(0, 0, 0.2, 1)',
    top: 'auto',
    left: '0',
    right: '0',
    bottom: '0',
    height: '60%',
    display: 'flex',
    zIndex: '1200',
    position: 'fixed',
    overflowY: 'auto',
    flexDirection: 'column',
    boxShadow:
      '0px 8px 10px -5px rgba(0, 0, 0, 0.2), 0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12)',
    color: 'rgba(0, 0, 0, 0.87)',
    backgroundColor: '#fff',
  },
  drawerRoot: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'hidden',
  },
  dialogContainerBackdrop: {
    opacity: '1',
    transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1)',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    display: 'flex',
    zIndex: '-1',
    position: 'fixed',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  titleCloseTop: {
    fontFamily: 'inherit',
    fontSize: theme.font.size18,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
    width: '100%',
    padding: '1px 0px',
  },
  titleArrow: {
    display: 'flex',
    margin: '20px 0 19.5px 16px',
    fontFamily: 'inherit',
    fontSize: '18px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
  },
  divider: {
    height: '1px',
    background: '#000',
    margin: '0px 14px 19.5px 14px',
  },
  closeArrow: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& img': {
      width: '16px',
      height: '16px',
      cursor: 'pointer',
    },
  },
  closeTop: {
    display: 'flex',
    justifyContent: 'end',
    '& img': {
      width: '24px',
      height: '24px',
    },
    border: 'none',
    background: 'none',
  },
  drawerHeaderClose: {
    display: 'flex',
    minHeight: 'auto', //"46px",
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 16px',
  },
  drawerHeaderCloseTop: {
    display: 'flex',
    minHeight: 'auto:', //"46px",
    justifyContent: 'space-between',
    alignItems: 'center',
    // padding: "10px 9px 10px 14px",
    padding: '16px 16px 6px 16px',
    flexDirection: 'row',
  },
  componentWrapper: {
    overflowY: 'auto',
  },
  modalFooter: {
    width: '100%',
    display: 'flex',
    padding: ' 14px 16px',
    marginTop: '16px',
    placeContent: 'center',
    borderTop: '1px solid #ddd',
  },
  modalButton: {
    width: '100%',
    height: '50px',
    borderRadius: '6px',
    border: 'solid 1px #ddd',
    backgroundColor: '#fff',
    // margin: "0px 4px",
    fontFamily: 'NotoSansKR',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
  },
  modalButtonLeft: {
    paddingRight: '4px',
  },
  modalButtonRight: {
    paddingLeft: '4px',
  },
  modalButtonDefault: {
    color: '#bbb',
    backgroundColor: '#999',
    border: '0px',
  },
  modalButtonStrong: {
    color: '#fff',
    backgroundColor: '#ea1917', //"#da0f47",
    border: '0px',
    fontWeight: 'bold',
  },
  modalButtonStrongDisabled: {
    color: '#bbb',
    backgroundColor: '#999',
  },
  modalGridContainer: {
    padding: '0px 16px',
  },

  modalGridItem: {
    marginBottom: '6px',
  },
  itemButton: {
    padding: '20px',
    width: '100%',
    height: '100%',
    border: '1px solid #fff',
    cursor: 'pointer',
    borderRadius: '6px',
    background: '#f6f6f6',
  },
  selected: {
    background: '#fff',
    border: '1px solid #000',
    borderRadius: '6px',
  },
  itemTitle: {
    fontFamily: 'inherit',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.36',
    letterSpacing: 'normal',
    color: '#000',
    textAlign: 'left',
  },
  itemText: {
    paddingTop: '2px',
    fontFamily: 'inherit',
    fontSize: theme.font.size12,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    color: '#000',
    textAlign: 'left',
  },
  modalPlainBtn: {
    minHeight: '46px',
    borderRadius: '6px',
    border: 'solid 1px #000',
    backgroundColor: '#fff',
    width: '100%',
    fontFamily: 'inherit',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
  },
  modalInnerItem: {
    padding: '0px',
    paddingRight: '8px',
  },
  modalInnerItemLast: {
    paddingRight: '0px',
  },
});
const PlaceType = withStyles(styles)((props) => {
  const { classes, modalClose, curModalValue, updateModalValue, orgData, scrollToRef } =
    props;
  const [selected, setSelected] = useState(curModalValue);
  const optionsText = {
    residence: '아파트, 빌라, 주택, 원룸 오피스텔(주거) 등',
    business:
      '상가 사무실, 숙박업소, 학교/관공서, 오피스텔(사무실), 기타(종교시설, 기숙사 등)',
  };
  const options = orgData?.data?.place_type_data?.Items || [];
  const slotEntity = orgData?.data?.place_type_data?.SlotEntity;
  const scrollRef = useRef(null);
  const handleNext = () => {
    modalClose('next');
  };
  const scrollDown = () => {
    scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
  };
  return (
    <div ref={scrollRef}>
      <Grid container className={classes.modalGridContainer}>
        {options.map((option, index) => (
          <Grid
            key={`rserve-place-${index}`}
            item
            xs={12}
            className={classes.modalGridItem}
          >
            <button
              className={[
                classes.itemButton,
                index === selected ? classes.selected : null,
              ].join(' ')}
              onClick={() => {
                updateModalValue(index); /*{
                  [slotEntity]:option.Entity
                });*/
                setSelected(index);
                scrollDown();
              }}
            >
              <div className={classes.itemTitle}>{option.Label}</div>
              <div className={classes.itemText}>{option.OutputText?.ko}</div>
            </button>
          </Grid>
        ))}
      </Grid>
      {/* footer button */}
      <Grid container className={classes.modalFooter}>
        <Grid item xs={12}>
          <button
            disabled={selected === null}
            className={[
              classes.modalButton,
              classes.modalButtonStrong,
              selected === null && classes.modalButtonStrongDisabled,
            ].join(' ')}
            onClick={handleNext}
          >
            다음
          </button>
        </Grid>
      </Grid>
    </div>
  );
});
function ReservePlace(props) {
  const { classes, data, modalOpen, modalClose, curModalValue, updateModalValue } = props;
  const { orgData, modalValue, linkData } = data || {
    orgData: null,
    modalValue: null,
    linkData: null,
  };
  const context = useContext(DataContext);
  const scrollToRef = useRef(null);
  const modalRef = useRef();

  useEffect(() => {
    if (modalOpen) {
      // 웹접근성 - 모달팝업 포커스 25-01
      const { current: modalElement } = modalRef;
      window.setTimeout(() => {
        modalElement.focus();
      });
    }
  }, [modalOpen]);

  const cancelReserve = () => {
    const defaultParameters = linkData?.parameters;
    const defaultExpect = linkData?.expect;
    let expectIntent = '';
    let byPassBrObj = { bypass_br: 'cancel' };
    expectIntent = 'THQ_ENGINEER_BOOK_BYPASS';
    context.request(
      context,
      defaultParameters?.speech || '취소',
      'button',
      {
        ...defaultParameters,
        ...byPassBrObj,
      },
      defaultExpect || {
        mode: 'bypass',
        intent: expectIntent,
      }
    );

    const rootChild = document.getElementById('root');
    const focusableElements = rootChild.querySelectorAll('*');

    for (let i = 0; i < focusableElements.length; i++) {
      focusableElements[i].removeAttribute('aria-hidden');
    }

    modalClose();
  };
  return createPortal(
    <div className={classes.root}>
      {/* <Drawer
        anchor="bottom"
        open={modalOpen}
        onClose={cancelReserve}
        classes={{ paper: classes.drawerFrame }}
      > */}
      {modalOpen && (
        <div className={classes.drawerContainer}>
          <div className={classes.dialogContainerBackdrop} aria-hidden="true"></div>
          <div className={classes.drawerFrame}>
            <div className={classes.drawerRoot}>
              <div className={classes.drawerHeaderCloseTop}>
                <div className={classes.titleCloseTop} ref={modalRef} tabIndex="0">
                  {' '}
                  출장서비스 예약을 위해 제품의 현재 사용 장소를 선택해 주세요.{' '}
                </div>
                <button className={classes.closeTop} onClick={cancelReserve}>
                  <img src={Close} className={classes.arrowDown} alt="닫기" />
                </button>
              </div>
              <Divider classes={{ root: classes.divider }} />
              <div className={classes.componentWrapper}>
                <PlaceType
                  curModalValue={curModalValue}
                  orgData={orgData}
                  updateModalValue={updateModalValue}
                  scrollToRef={scrollToRef}
                  modalClose={modalClose}
                  cancelReserve={cancelReserve}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {/* </Drawer> */}
    </div>,
    document.getElementById('modal')
  );
}
export default withStyles(styles)(ReservePlace);
